import { Action } from '@ngrx/store';

import { AssessmentActivityDetailInterface } from '../../models/assessment-activity-detail.model';

import { ActivityReportActionType } from './activity-report-action-type.enum';

export class LoadAssessmentActivityData implements Action {
  public readonly type: ActivityReportActionType = ActivityReportActionType.LoadAssessmentActivityData;
  public readonly payload: any = undefined;
}

export class LoadAssessmentActivityDataCompleted implements Action {
  public readonly type: ActivityReportActionType = ActivityReportActionType.LoadAssessmentActivityDataCompleted;

  constructor(public readonly payload: AssessmentActivityDetailInterface[]) { }
}

export class LoadAssessmentActivityDataFailed implements Action {
  public readonly type: ActivityReportActionType = ActivityReportActionType.LoadAssessmentActivityDataFailed;

  constructor(public readonly payload: string) { }
}
